// eslint-disable-next-line import/prefer-default-export
export const DYNAMIC_FORM_MODE = {
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  CREATE: 'CREATE',
};
